import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import locateBg from "@angular/common/locales/bg";

registerLocaleData(locateBg);

import { AngularFireAnalyticsModule } from "@angular/fire/analytics";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ClarityModule } from "@clr/angular";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./components/app/login/login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { CompleteComponent } from "./components/complete/complete.component";
import { HeaderComponent } from "./components/app/header/header.component";
import { LoadingComponent } from "./components/app/loading/loading.component";
import { FooterComponent } from "./components/app/footer/footer.component";
import { NotificationComponent } from "./components/app/notification/notification.component";
import { EditrecipesComponent } from "./components/editrecipes/editrecipes.component";
import { RecepieGridComponent } from "./components/editrecipes/recepie-grid/recepie-grid.component";
import { registerLocaleData } from "@angular/common";
import { environment } from "src/environments/environment";
import { AngularFireModule } from "@angular/fire";
import { SubstitudeDefineComponent } from "./components/editrecipes/substitude-define/substitude-define.component";
import { ResultTreeComponent } from "./components/editrecipes/result-tree/result-tree.component";
import { ProgressComponent } from "./components/app/progress/progress.component";
import { LogMonitorModule } from "ngx-log-monitor";
import { SubproductComponent } from "./components/subproducts/subproducts.component";
import { SubproductsTreeComponent } from "./components/subproducts/subproducts-tree/subproducts-tree.component";
import { StoreFilterPipe } from './store-filter.pipe';
import { ProductStructureComponent } from "./components/product-structure/product-structure.component";
import { ProductTypeGridComponent } from "./components/product-structure/product-type-grid/product-type-grid.component";
import { ProductTypeGridGruopedComponent } from "./components/product-structure/product-type-grid-grouped/product-type-grid-grouped.component";
import { AnalysisPOComponent } from "./components/analysis-po/analysis-po.component";
import { PoPrintsComponent } from "./components/analysis-po/po-prints/po-prints.component";
import { PoTreeComponent } from "./components/analysis-po/po-tree/po-tree.component";
import { PoAnalisysComponent } from "./components/analysis-po/po-analysis/po-analysis.component";
import { SalesComponent } from "./components/sales/sales.component";
import { PoWorkCardComponent } from "./components/analysis-po/po-work-cards/po-work-cards.component";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    CompleteComponent,
    HeaderComponent,
    LoadingComponent,
    FooterComponent,
    NotificationComponent,
    EditrecipesComponent,
    SubproductComponent,
    RecepieGridComponent,
    SubstitudeDefineComponent,
    ResultTreeComponent,
    ProgressComponent,
    SubproductsTreeComponent,
    ProductStructureComponent,
    ProductTypeGridComponent,
    ProductTypeGridGruopedComponent,
    AnalysisPOComponent,
    PoPrintsComponent,
    PoTreeComponent,
    PoWorkCardComponent,
    PoAnalisysComponent,
    SalesComponent,
    StoreFilterPipe,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    ClarityModule,
    BrowserAnimationsModule,
    LogMonitorModule,

    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule,
  ],
  providers: [{ provide: LOCALE_ID, useValue: "bg" }],
  bootstrap: [AppComponent],
})
export class AppModule { }
